<template>
  <data-list
    ref="dataList"
    class="content md"
    :url="url"
    query="&sort=-id"
    entity-name="供奉物品"
    add-btn="添加供奉物品"
    hide-show-detail
    :search-key-type="searchKeyType"
    :modalWidth="600"
    :rules="rules"
    :columns="columns"
    :action="action"
  >
    <template v-slot:query="{ form }">
      <a-form-model-item label="供奉物品名称">
        <a-input v-model="form.name" placeholder="输入供奉物品名称查询" allow-clear />
      </a-form-model-item>
    </template>
    <template v-slot:button>
      <a-button @click="setting">设置</a-button>
    </template>
    <template v-slot:edit="{ form }">
      <a-form-model-item label="供奉物品名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入供奉物品名称" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="价格" prop="price">
        <div class="flex-box align-center">
          <a-input-number
            v-model="form.price"
            placeholder="输入供奉物品价格"
            :min="1"
            :precision="2"
            :formatter="(value) => value / 100"
            :parser="(value) => value * 100"
          ></a-input-number>
          <span class="unit" style="margin-left: 12px">元</span>
        </div>
      </a-form-model-item>
      <a-form-model-item label="请上传图片" prop="img">
        <form-upload v-model="form.img" :limit="9"></form-upload>
      </a-form-model-item>
      <a-form-model-item label="详情" prop="info">
        <a-textarea v-model="form.info" :rows="4" placeholder="请输入详情"></a-textarea>
      </a-form-model-item>
    </template>
  </data-list>
</template>

<script>
import light from "../../common/mixins/light";

export default {
  name: "GoodsList",
  mixins: [light],
  data() {
    return {
      columns: [
        { title: "物品名称", dataIndex: "name" },
        {
          title: "图片",
          dataIndex: "img",
          customRender: (text) => (text && text.split(",").length > 0 ? <s-img src={text.split(",")[0]} /> : "--"),
        },
        { title: "价格", dataIndex: "price", customRender: (text) => `¥ ${(text / 100).toFixed(2)}` },
      ],
      rules: {
        name: [{ required: true, message: "请输入物品名称", trigger: "blur" }],
        price: [{ required: true, message: "请输入价格", trigger: "change" }],
        img: [{ required: true, message: "请上传图片", trigger: "change" }],
        info: [{ required: true, message: "请输入详情", trigger: "blur" }],
      },
      searchKeyType: {
        name: 1,
      },
    };
  },
  computed: {
    action() {
      return this.$route.meta.action;
    },
    url() {
      return `/admin/${this.apiPrefix}-worship-item`;
    },
  },
  methods: {
    setting() {
      this.$router.push({ name: "GoodsSet" });
    },
  },
};
</script>

<style lang="less" scoped></style>
